import momentEU from 'moment/locale/eu'

const components = {
  momentName: 'eu',
  momentLocale: momentEU
}

const locale = {
  'message': '-',
  'layouts.EmailMarketing': 'EmailMarketing',
  'layouts.application': 'Application',
  'layouts.current': 'current',
  'layouts.switch': 'Switch {0}',
  'layouts.old.version': 'Old',
  'layouts.new.version': 'New',
  'layouts.new': 'New',
  'layouts.edit': 'Edit',
  'layouts.show': 'Show {0}',
  'layouts.hide': 'Hide {0}',
  'layouts.paidPage': 'paid page',
  'layouts.expired': 'Expired',
  'layouts.upgrade': 'Upgrade',
  'layouts.buy': 'Buy',
  'layouts.onlineservice': 'Online Service',
  'layouts.MoneyAssistant': 'Financ Manage',
  'layouts.accountSettings': 'Account Settings',
  'layouts.usercenter': 'User Center',
  'layouts.authority': 'Authority Management',
  'layouts.store.authorization': 'Store Authorization',
  'layouts.helpcenter': 'Help Center',
  'layouts.menusyl': 'Menu Style',
  'layouts.menusyl.top': 'Top menu layout',
  'layouts.menusyl.left': 'Side menu layout',
  'layouts.menutransformation': 'Menu Change',
  'layouts.logout': 'Logout',
  'layouts.allapplication': 'Applications',
  'layouts.history': 'history',
  'layouts.customscene': '{0} Custom Scene',
  'layouts.demo.tips': 'The DEMO environment does not support this operation. You can use your own account to operate this function',
  'layouts.customscene.currentNoDel': 'The scene in use is not allowed to be deleted. Please switch to another scene before deleting',
  'layouts.allmenu': 'All Menu',
  'layouts.menusearch': 'Please enter keywords, search menu',
  'layouts.commonmenu': 'History',
  'layouts.search.placeholder': 'Please input keywords, search menu',
  'layouts.text.undefined': 'undefined',
  'layouts.operation.guide': 'Operation guide',
  'layouts.bookmarks': 'Bookmarks',
  'layouts.bookmarks.success': 'Bookmarks successfully',
  'layouts.bookmarks.cancel': 'Unbookmarked successfully',
  'layouts.openAll': 'Open All',
  'layouts.manageFavorites': 'Manage Favorites',
  'layouts.ViewAll': 'View All',
  'layout.searchKeyword': 'Search Keyword',

  'version-modal.title': 'Switching instructions',
  'version-modal.tips': 'This switch will not be returned to the current version, you can also check the introduction of the new version for a comprehensive understanding',
  'version-modal.info': 'After switching to Easy ERP, there will be the following changes:',
  'version-modal.subInfo-1': 'System Ul changes',
  'version-modal.subInfo-2': 'Change of menu order',
  'version-modal.subInfo-3': 'Functions may be deleted and added accordingly, but will not affect the basic business process',
  'version-modal.footer': 'I have understood the above situation and agreed to switch.',
  'version-modal.viewDemo': 'View Demo',

  'store-tip.title': 'A Sharp weapon for sealing a essential for in vogue goods',
  'store-tip.subtitle': '2 mins fast authorization',
  'store-tip.guide': 'High technology constructing accurate marketing operations',
  'store-tip.info-1': 'Multi-shops management<br>auto anti-associations',
  'store-tip.info-2': 'Live dates updating<br>safe and reliable',
  'store-tip.info-3': 'In time warning for<br>operation risks',
  'store-tip.remind': 'No more reminders for this login',
  'store-tip.btn': 'START AUTHORIZATION',

  'form-modal.cancel': 'Cancel',
  'form-modal.submit': 'Save',
  'form-modal.delete': 'Delete',
  'form-modal.selected': 'Selected',
  'form-modal.action': 'Action',
  'form-modal.third-party-abnormal': 'The third-party system is abnormal!',
  'form-modal.custom.title': 'Custom Scene menus',
  'form-modal.customMenuName': 'Scene name',
  'form-modal.system.title': 'Custom System menus',
  'form-modal.menuname.placeholder': 'Please enter a name',
  'form-modal.remark.placeholder': 'remarks',
  'form-modal.rule.maxstring': 'Supports up to {0} strings',
  'form-modal.rule.maxobject': 'Choose a maximum of 2 items',
  'form-modal.rule.select': 'Please select {0}',
  'notification-modal.title.prompt': 'Warm prompt',
  'notification-modal.content.delete.customscene': 'Are you sure to delete the scene? This operation is unrecoverable',
  'notification-modal.content.maxcustomscene': 'Up to 30 scenes can be created, and you can delete obsolete scenes or edit existing ones',
  'logout.title': 'Message',
  'logout.content': 'Are you sure you would like to logout?',
  'logout.okText': 'OK',
  'logout.cancelText': 'Cancel',

  'tabs.close.current': 'Close current tab',
  'tabs.close.right': 'Close right',
  'tabs.close.left': 'Close left',
  'tabs.close.all': 'Close all'
}

export default {
  ...components,
  ...locale
}
